/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional evaluation run id the feedback targets
 */
export type StudentEvaluationFeedbackRequestRunId = string | null;
